import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import AddTimeOffComponent from '../components/AddTimeOffComponent'

const mapStateToProps = (state) => {
  return {
    vacation: state.vacation,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTimeOffComponent)
